import {
  FETCH_DASHBOARD,
  FETCH_GRAFICAS_FAVORITAS,
  FETCH_CONTADORES,
  FETCH_ULTIMOS_SENSORES,
  FETCH_CONSUMO_ENERGIA,
  TOGGLE_FAVORITE_GRAFICA,
  SET_DASHBOARD_LOADING,
  SET_DASHBOARD_ERROR
} from '../actions/types';
import { handleAction } from '../utils/handleAction';

const initialState = {
  loading: false,
  error: null,
  data: null,
  graficasFavoritas: [],
  contadores: {
    proyectos: 0,
    tarjetas: { activas: 0, total: 0, porcentajeActivo: 0 },
    sensores: { activos: 0, total: 0, porcentajeActivo: 0 }
  },
  ultimosSensores: [],
  consumoEnergia: {
    totalConsumo: 0,
    consumoPorTipo: {},
    consumoPorDia: [],
    sensoresIncluidos: 0,
    periodoCalculado: null
  },
  userInfo: null,
  lastUpdated: null,
  isLoading: false
};

const dashboardReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_DASHBOARD:
      return handleAction(state, action, {
        failure: (prevState) => ({
          ...prevState,
          error: payload?.message || 'Error al cargar el dashboard'
        }),
        success: (prevState) => ({
          ...prevState,
          data: payload,
          graficasFavoritas: payload.graficasFavoritas || [],
          contadores: payload.contadores || initialState.contadores,
          ultimosSensores: payload.ultimosSensores || [],
          consumoEnergia: payload.consumoEnergia || initialState.consumoEnergia,
          userInfo: payload.userInfo || null,
          lastUpdated: new Date().toISOString(),
          error: null
        })
      });

    case FETCH_GRAFICAS_FAVORITAS:
      return handleAction(state, action, {
        failure: (prevState) => ({
          ...prevState,
          error: payload?.message || 'Error al cargar gráficas favoritas'
        }),
        success: (prevState) => ({
          ...prevState,
          graficasFavoritas: payload,
          error: null
        })
      });

    case FETCH_CONTADORES:
      return handleAction(state, action, {
        failure: (prevState) => ({
          ...prevState,
          error: payload?.message || 'Error al cargar contadores'
        }),
        success: (prevState) => ({
          ...prevState,
          contadores: payload,
          error: null
        })
      });

    case FETCH_ULTIMOS_SENSORES:
      return handleAction(state, action, {
        failure: (prevState) => ({
          ...prevState,
          error: payload?.message || 'Error al cargar últimos sensores'
        }),
        success: (prevState) => ({
          ...prevState,
          ultimosSensores: payload,
          error: null
        })
      });

    case FETCH_CONSUMO_ENERGIA:
      return handleAction(state, action, {
        failure: (prevState) => ({
          ...prevState,
          error: payload?.message || 'Error al cargar consumo de energía'
        }),
        success: (prevState) => ({
          ...prevState,
          consumoEnergia: payload,
          error: null
        })
      });

    case TOGGLE_FAVORITE_GRAFICA:
      return handleAction(state, action, {
        failure: (prevState) => ({
          ...prevState,
          error: payload?.message || 'Error al cambiar estado de favorito'
        }),
        success: (prevState) => ({
          ...prevState,
          graficasFavoritas: prevState.graficasFavoritas.map(grafica =>
            grafica._id === action.meta.id 
              ? { ...grafica, favorita: action.meta.favorita }
              : grafica
          ),
          error: null
        })
      });

    case SET_DASHBOARD_LOADING:
      return {
        ...state,
        loading: payload,
        isLoading: payload
      };

    case SET_DASHBOARD_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
        isLoading: false
      };

    default:
      return state;
  }
};

export default dashboardReducer;
